import { domain } from './webURL'

const backendHost = `https://services.${domain}/`

export const API_ROOT = backendHost



// WEBPACK FOOTER //
// ./src/api-config.js